export * from "modules/TyreDiscountsDashboard/components/AddUpdateTyreDiscountModal/hooks/useAddTyreDiscountMutation";
export * from "modules/TyreDiscountsDashboard/components/AddUpdateTyreDiscountModal/hooks/useUpdateTyreDiscountMutation";
